import {
  contentControllerInitContentUpload,
  contentControllerStartContentUpload,
  type InitContentUploadDtoKind,
} from "./generated"

export const uploadBrowserContent = async ({
  kind,
  files,
  socketClientId,
}: {
  kind: InitContentUploadDtoKind
  files: File[]
  socketClientId?: string
}) => {
  const initialized = await contentControllerInitContentUpload({
    kind,
    files: files.map(file => ({
      filename: file.name,
      contentType: file.type || "application/octet-stream",
      size: file.size,
    })),
  })

  await Promise.all(
    initialized.uploads.map(async target => {
      const file = files[target.index]
      if (!file) throw new Error("Upload target does not match a local file")
      const response = await fetch(target.uploadUrl, {
        method: "PUT",
        headers: target.headers as Record<string, string>,
        body: file,
      })
      if (!response.ok) {
        throw new Error(`File upload failed (HTTP ${response.status})`)
      }
    })
  )

  return contentControllerStartContentUpload(initialized.uploadId, {
    socketClientId,
  })
}
